import { REBRANDING_COM_TOGGLE } from 'shared/experiments/consts/names'
import { EXPERIMENT_VARIATION } from 'shared/experiments/consts/variants'
import type { Experiment } from 'types/shopConfig'

export const rebrandingComExperiment: Experiment = {
  name: REBRANDING_COM_TOGGLE,
  isEnabled: true,
  variables: { f: 1 },
  variant: EXPERIMENT_VARIATION.V1,
}
